module.exports = __webpack_public_path__ + "static/media/47_A.d61b405d.png";